import axios from 'axios'
import VUE_APP_API_HEMERA_URL from './getapi/hemera'

let apiURL = ''
if (process.env.NODE_ENV === "development") {
	// alert("开发环境");
	apiURL = 'http://proxy.jiankanghao.net:50208/api/v1'
	// apiURL = 'https://hemera.haiweikexin.com/api/v1'
} else {
	// alert("生产环境");
	apiURL = VUE_APP_API_HEMERA_URL
}

let http = axios.create({
	timeout: 12000,
	baseURL: apiURL,
	// baseURL: 'http://192.168.0.212:8072/api/v1/',
	headers: {
		'Content-Type': 'application/json;charset=UTF-8;'
	}
});
export default http;



// WEBPACK FOOTER //
// ./src/util/hermerApiConfig.js